import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {List, WhiteSpace, Flex, ActivityIndicator} from 'antd-mobile';
import UserCarService from "../../apiServices/UserCarService";
import {Link} from "react-router-dom";
import OrderService from "../../apiServices/OrderService";
import {Button, Icon, notification} from "antd";
import CarInsuranceService from "../../apiServices/CarInsuranceService";

class CarDetail extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('id');

        this.state = {
            hasError: false,
            height: '100%',
            object_id: object_id,
            userCar: null,
            order: null,
            carInsurances: [],
            brandLogo:'no-image',
            showLoading: true,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
        if(this.state.object_id){
            UserCarService.detail(this.state.object_id).then(response=>{
                this.setState({
                    userCar: response.data,
                    brandLogo: response.data.car_brand.alias,
                    showLoading: false,
                });
            }).catch(function(error){
                console.log(error);
            });

            CarInsuranceService.getlist(this.state.object_id).then(response=>{
                this.setState({carInsurances: response.data});
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.push('/');
        }
    }

    buyInsurance = () => {
        OrderService.findByObjectId(this.state.object_id).then(response=>{
            if(response.code === 3){
                this.props.history.push('/mua-bao-hiem?object_id='+this.state.object_id);
            }else if(response.data.stat === 1){
                this.props.history.push('/chon-hang-bao-hiem?object_id='+this.state.object_id);
            }else if(response.data.stat === 2 && this.state.userCar.stat === 3){
                notification.success({
                    message: 'Thông tin hợp đồng đang được thẩm định',
                    description: '',
                });
            }else if(response.data.stat === 2){
                this.props.history.push('/hoan-thien-ho-so?object_id='+this.state.object_id);
            }else {
                this.props.history.push('/chi-tiet-hop-dong?object_id='+this.state.object_id);
            }
        }).catch(function(error){
            console.log('Lỗi: '+error);
        });
    };

    render() {
        let userCarInfo;
        if (this.state.showLoading===true) {
            userCarInfo = (<ActivityIndicator toast text="Loading..." animating={this.state.showLoading}/>);
        }else if (this.state.userCar){
            let insBrand;
            let requestClaim;
            let btnBuyInsurance;
            if (this.state.carInsurances.length === 0){
                insBrand = (<div style={{ color: '#000', fontSize: '14px', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
                    <span>Chưa có thông tin Bảo hiểm</span></div>);
                requestClaim = (<div className='boxBuyNow insInfoBoxBuy'>
                    <Link to={'/thong-tin-bao-hiem?object_id='+this.state.userCar.id} className="ant-btn btn-claim" style={{padding: '10px 20px'}}>Đã có Bảo hiểm?</Link>
                </div>);
                btnBuyInsurance = (<div className='boxBuyNow insInfoBoxBuy'>
                    <Button onClick={() => this.buyInsurance()} className="ant-btn btn-next-action">Mua Bảo hiểm</Button>
                </div>);
            }else{

                let IconEdit = (<Icon type="eye" style={{marginLeft: '7px'}} onClick={() => this.props.history.push('/mua-bao-hiem?object_id='+this.state.object_id)} />);
                let IconEdit1 = (<Icon type="edit" style={{marginLeft: '7px'}} onClick={() => this.props.history.push('/thong-tin-bao-hiem?object_id='+this.state.object_id)} />);

                insBrand = this.state.carInsurances.map((item, index) => (
                    <div style={{ color: '#000', fontSize: '14px', padding: '15px 0', borderBottom: '1px solid #ddd' }}>
                        <img src={require('../../resources/images/logos/insur_brand_'+item.insurance_id+'.png')}
                             style={{ width: '32px', height: '32px', marginRight:'8px' }} alt="" />
                        <span>{item.insurance.name}
                            { (item.is_insunow === 1 && item.stat === 1) ? IconEdit : '' }
                            { (item.is_insunow === 0) ? IconEdit1 : '' }
                        </span>
                        <br/>
                        <span>Giá trị HĐ: {Number(item.amount).toLocaleString('en')+'đ'} | Bồi thường: 0đ</span>
                    </div>
                ));

                requestClaim = (<div className='boxBuyNow insInfoBoxBuy'>
                    <Link to={'/tao-yeu-cau-boi-thuong?object_id='+this.state.userCar.id} className="ant-btn btn-claim">Yêu cầu Bồi thường</Link>
                </div>);
                btnBuyInsurance = (<div className='boxBuyNow insInfoBoxBuy'>
                    <Button onClick={() => this.props.history.push('/gia-han-hop-dong?object_id='+this.state.userCar.id)}
                            className="ant-btn btn-next-action" style={{padding: '10px 16px'}}>Gia hạn Hợp đồng</Button>
                </div>);
            }
            let plateNumber;
            if(this.state.userCar.plate_number===null){
                plateNumber = (<Link to={'/update-thong-tin-xe?update=1&id='+this.state.userCar.id} className="ant-btn btn-claim">Thêm biển số</Link>);
            }else{
                plateNumber = (<span style={{textTransform: 'uppercase'}}>{this.state.userCar.plate_number}</span>);
            }
            userCarInfo = (<div>
                <Flex style={{borderBottom: '1px solid #ddd'}}>
                    <Flex.Item style={{borderRight: '1px solid #ddd' }}>
                        <div style={{ padding: '12.5px', textAlign: 'center' }}>
                            <img src={require('../../resources/images/logo_cars/'+this.state.brandLogo+'.png')} style={{ width: '75%', height: '75%' }} alt="" />
                            <div style={{ color: '#000', fontSize: '14px', marginBottom: '10px' }}>
                                <span>{this.state.userCar.car_product.name}</span>
                            </div>
                        </div>
                    </Flex.Item>
                    <Flex.Item>
                        <div style={{ padding: '12.5px', textAlign: 'center' }}>
                            <div style={{ color: '#000', fontSize: '30px', marginTop: '12px' }}>
                                {plateNumber}
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item>
                        <div style={{ textAlign:'center' }}>
                            {insBrand}
                        </div>
                    </Flex.Item>
                </Flex>

                <List className="insInfoBox" style={{ marginTop: '7px', paddingTop: '10px' }}>
                    {requestClaim}
                    {btnBuyInsurance}
                </List>
            </div>);
        }

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} showEditBtn={true} itemID={this.state.object_id} title="Thông tin xe" classNameContent="bgWhite"
                               page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content">
                        <WhiteSpace size='xl' />
                        {userCarInfo}
                    </div>
                </DefaultLayout>
            </div>
        )
    }
}

export default (withTranslation())(CarDetail);